import { render } from "./HHSChange.vue?vue&type=template&id=bbd772b2&scoped=true"
import script from "./HHSChange.vue?vue&type=script&lang=js"
export * from "./HHSChange.vue?vue&type=script&lang=js"

import "./HHSChange.vue?vue&type=style&index=0&id=bbd772b2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bbd772b2"

export default script